<template>
  <v-main style="min-height: 70vh">
    <v-container class="responsive-template-content">
      <v-row dense>
        <v-col cols="12">
          <v-col class="col-md-12 col-sm-12 col-xs-12">
            <v-card color="white" dark class="rounded-xl">
              <v-card-title
                class="justify-center text-h5 font-weight-light"
                style="color: #1976d2"
              >
                <v-icon style="padding-right: 0.3em; color: #1976d2"
                  >mdi-folder-table-outline
                </v-icon>
                Gérer mes candidatures
              </v-card-title>

              <v-card-subtitle>
                <section
                  style="background: rgba(255, 255, 255, 0.9); color: #777171"
                >
                  <v-col>
                    <v-alert
                      border="left"
                      colored-border
                      type="info"
                      elevation="2"
                      light
                      v-if="currentCvFilePath !== ''"
                    >
                      <a target="_blank" v-if="currentCvFilePath !== '#'" :href="currentCvFilePath">
                        Télécharger une copie de mon CV.
                      </a>
                      <a target="_blank" title="Vous n'avez uploadé aucun cv" v-if="currentCvFilePath === '#'">
                        Télécharger une copie de mon CV.
                      </a>
                    </v-alert>
                    <v-card light>
                      <v-card-title>
                        <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Rechercher"
                          single-line
                          hide-details
                          light
                        ></v-text-field>
                      </v-card-title>
                      <v-data-table
                        :headers="headers"
                        :items="applicationsData"
                        class="elevation-1"
                        light
                        :search="search"
                        :footer-props="{
                          'items-per-page-text': 'Alertes par page',
                          'items-per-page-options': [5, 10, 15, 20],
                        }"
                      >
                        <template v-slot:item.state="{ item }">
                          <v-chip :color="getColor(item.state)" dark>
                            {{ item.state }}
                          </v-chip>
                        </template>

                        <template v-slot:item.lm="{ item }">
                          <v-col cols="auto">
                            <v-dialog
                              transition="dialog-top-transition"
                              width="60vw"
                              scrollable
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn light v-bind="attrs" v-on="on"
                                  >Consulter
                                </v-btn>
                              </template>
                              <template v-slot:default="dialog">
                                <v-card>
                                  <v-card-title
                                    color="primary"
                                    dark
                                    class="justify-center text-h5 font-weight-light"
                                    style="color: #1976d2"
                                  >
                                    Candidature à l'offre :
                                    {{
                                      item.lm.jobOffer.job.name +
                                      " - " +
                                      item.lm.jobOffer.type.name
                                    }}
                                  </v-card-title>
                                  <v-card-subtitle style="margin-top: 1em">
                                    <v-card
                                      elevation="0"
                                      border="left"
                                      colored-border
                                      type="info"
                                    >
                                      <v-card-title
                                        >Résumé de l'offre</v-card-title
                                      >
                                      <v-card-text>
                                        <v-row>
                                          <v-col
                                            cols="12"
                                            md="6"
                                            class=""
                                            style="font-size: large"
                                          >
                                            <span class="font-weight-black">
                                              <v-icon>
                                                mdi-home-city-outline
                                              </v-icon>
                                              Entreprise :
                                            </span>
                                            <router-link
                                              :to="`/company/page/${item.lm.jobOffer.company.id}`"
                                              >{{
                                                item.lm.jobOffer.company.name
                                              }}</router-link
                                            >
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            md="6"
                                            class=""
                                            style="font-size: large"
                                          >
                                            <span class="font-weight-black">
                                              <v-icon>
                                                mdi-calendar-month-outline
                                              </v-icon>
                                              Date de publication :
                                            </span>
                                            {{
                                              new Date(
                                                item.lm.jobOffer.createdAt
                                              ).toLocaleString("fr-FR")
                                            }}
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            md="6"
                                            style="
                                              font-size: large;
                                              margin-top: -0.8em;
                                            "
                                          >
                                            <span class="font-weight-black">
                                              <v-icon> mdi-domain </v-icon>
                                              Secteur :
                                            </span>
                                            {{
                                              item.lm.jobOffer.job
                                                .activitySector.name
                                            }}
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            md="6"
                                            style="
                                              font-size: large;
                                              margin-top: -0.8em;
                                            "
                                          >
                                            <span class="font-weight-black">
                                              <v-icon>
                                                mdi-map-marker-multiple-outline
                                              </v-icon>
                                              Lieu de travail :
                                            </span>
                                            {{ item.lm.jobOffer.jobLocation }}
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            md="6"
                                            style="
                                              font-size: large;
                                              margin-top: -0.8em;
                                            "
                                          >
                                            <span class="font-weight-black">
                                              <v-icon>
                                                mdi-map-marker-multiple-outline
                                              </v-icon>
                                              Salaire :
                                            </span>
                                            {{ item.lm.jobOffer.remuneration }}
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            md="6"
                                            style="
                                              font-size: large;
                                              margin-top: -0.8em;
                                            "
                                          >
                                            <span class="font-weight-black">
                                              <v-icon>
                                                mdi-file-certificate-outline
                                              </v-icon>
                                              Type d'offre :
                                            </span>
                                            {{ item.lm.jobOffer.remuneration }}
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            md="6"
                                            style="
                                              font-size: large;
                                              margin-top: -0.8em;
                                            "
                                          >
                                            <span class="font-weight-black">
                                              <v-icon>
                                                mdi-file-certificate-outline
                                              </v-icon>
                                              Début d'activités :
                                            </span>
                                            {{ item.lm.jobOffer.startDate }}
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            md="6"
                                            style="
                                              font-size: large;
                                              margin-top: -0.8em;
                                            "
                                          >
                                            <span class="font-weight-black">
                                              <v-icon>
                                                mdi-file-certificate-outline
                                              </v-icon>
                                              Durée :
                                            </span>
                                            {{
                                              item.lm.jobOffer.duration !== null
                                                ? item.lm.jobOffer.duration
                                                : "-"
                                            }}
                                          </v-col>
                                        </v-row>
                                      </v-card-text>
                                    </v-card>
                                  </v-card-subtitle>
                                  <v-card-text>
                                    <v-card
                                      elevation="0"
                                      border="left"
                                      colored-border
                                      type="info"
                                    >
                                      <v-card-title
                                        >Lettre de motivation</v-card-title
                                      >
                                      <v-card-text v-text="item.lm.coverLetter">
                                      </v-card-text>
                                    </v-card>
                                    <div class=""></div>
                                  </v-card-text>
                                  <v-card-actions class="justify-end">
                                    <v-btn text @click="dialog.value = false"
                                      >Fermer
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </template>
                            </v-dialog>
                          </v-col>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </section>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
    <Footer />
  </v-main>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";

export default Vue.extend({
  name: "CandidateMyApplications",
  components: {},
  data: () => ({
    search: "",
    dialog: false,
    snackbarFailed: false,
    snackbarSuccess: false,
    currentCvFilePath: "",
    headers: [
      {
        text: "Offre",
        align: "start",
        sortable: true,
        value: "work",
      },
      { text: "Entreprise", value: "company", sortable: true },
      { text: "Date de candidature", value: "savedAt", sortable: true },
      { text: "Etat", value: "state", sortable: false },
      { text: "Lettre de motivations", value: "lm", sortable: false },
    ],
    applicationsData: [],
    applications: null,
    currentAlertToDelete: null,
  }),
  computed: {},

  watch: {},

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const httpClient = new HttpClient();
      httpClient
        .getCurrentUserApplications(localStorage.getItem("jwt-token"))
        .then((res) => {
          if (res.data.length > 0) {
            if (res.data[0].seeker.cv) {
              this.currentCvFilePath = `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/uploads/cv/${res.data[0].seeker.cv.fileName}`;
            } else {
              this.currentCvFilePath = "#";
            }
          }
          this.applications = res.data;
          this.applicationsData = [];
          res.data.map((elt) => {
            let state = "";
            if (elt.jobOffer.isDeleted) {
              state = "Non retenue";
            } else {
              state = "Transmise";
            }
            this.applicationsData.push({
              work: elt.jobOffer.job.name + " - " + elt.jobOffer.type.name,
              company: elt.jobOffer.company.name,
              savedAt: new Date(elt.date).toLocaleString("fr-FR"),
              state,
              lm: elt,
            });
          });
        })
        .catch((error) => {
          alert(error);
          console.log(error);
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        });
    },

    editItem(item) {
      this.editedIndex = this.applicationsData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.dialog = true;
      this.currentAlertToDelete = item;
    },

    deleteItemForReal() {
      this.dialog = false;
      const item = this.currentAlertToDelete;
      this.currentAlertToDelete = null;
      const httpClient = new HttpClient();
      httpClient
        .deleteAlert(item.id, localStorage.getItem("jwt-token"))
        .then(() => {
          this.initialize();
          this.snackbarSuccess = true;
          setTimeout(() => {
            this.snackbarSuccess = false;
          }, 3000);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else {
            this.snackbarFailed = true;
            setTimeout(() => {
              this.snackbarFailed = false;
            }, 3000);
          }
        });
    },

    getColor(state) {
      if (state === "Transmise") return "green";
      else return "red";
    },
  },
});
</script>

<style scoped></style>
